import { Separator as SeparatorPrimitive } from "@base-ui/react/separator";

import { cnState } from "@beweegbaas/ui/lib/utils";

function Separator({ className, orientation = "horizontal", ...props }: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      className={cnState(
        `bg-border shrink-0 data-[orientation=horizontal]:h-px
        data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px
        data-[orientation=vertical]:self-stretch`,
        className,
      )}
      {...props}
    />
  );
}

// Export SeparatorPrimitive for advanced use cases
export { Separator, SeparatorPrimitive };
